import ProductCategoryAccordion from '@/components/products/refill/ProductCategoryAccordion';
import { CantOrderDevices } from './CantOrderDevices';
import { CantOrderProducts } from './CantOrderProducts';
import { ProductMatchIssues } from './ProductMatchIssues';
import type { UnavailableProductsSectionProps } from './types';

export function UnavailableProductsSection({
  productMatchIssues,
  cantOrderDevices,
  cantOrderProducts,
  showExpanded = false,
}: UnavailableProductsSectionProps) {
  const totalCount = cantOrderProducts.length + productMatchIssues.length + cantOrderDevices.length;

  if (totalCount === 0) {
    return null;
  }

  return (
    <ProductCategoryAccordion label="Can't order now" count={totalCount} startCollapsed={!showExpanded} stickyHeader>
      <ProductMatchIssues issues={productMatchIssues} />
      <CantOrderDevices devices={cantOrderDevices} />
      <CantOrderProducts products={cantOrderProducts} />
    </ProductCategoryAccordion>
  );
}
